module.exports = __webpack_public_path__ + "img/casa.3ea8740d.jpg";